export class AuthModel {
  isAuthenticated: boolean = false;
  rolCode: string = '';
  labelRol: string = '';
  email: string = '';
  fullName: string = '';
  registerDate: Date = new Date();
  idUser: number = 0;
}